import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './style.scss'
import { signMessageToken, SupportedWallets } from 'constants/wallet'
import {
  getAddress,
  loadEventWallet,
  loadWallet,
  requestConnectToDApp,
  requestDisconnectDApp,
  signMessage,
} from 'wallet/ether'
import { loginExternalWallet } from 'services/auth'
import { setAccessToken } from 'utils/sendRequest'
import { setModalWallet } from 'store/wallet/walletSlice'
import { ReactComponent as Metamask } from 'assets/svgs/metamask.svg'
import { setWalletType } from 'wallet/wallet'
import { Toast, ToastContainer } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { getUser, setUser } from 'store/user/storage'
import { setDataUser } from 'store/user/userSlice'
import { selectWallet } from 'store/wallet/selectors'
import { IErrorMessage } from 'services/type'
import { useTranslation } from 'react-i18next'

const ConnectWalletPage = () => {
  const [isLoading, setLoading] = useState(false)
  const [toast, setToast] = useState('')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { address } = useSelector(selectWallet)
  const { t } = useTranslation()

  async function collectWallet(type: SupportedWallets) {
    try {
      if (isLoading) return
      setLoading(true)
      await requestConnectToDApp(type)

      const address = await getAddress()

      const signature = (await signMessage(signMessageToken).catch(
        () => {}
      )) as string | undefined

      const rest = await loginExternalWallet({ address, signature }).catch(
        () => {}
      )
      if (
        !rest ||
        !(rest.status >= 200 && rest.status <= 299) ||
        !rest.data.access_token
      ) {
        callToast((rest?.data as unknown as IErrorMessage).description)
        const restData: any = rest?.data
        if (restData?.messageCode === 'USER.NOT_HAVE_THE_ROLE_OF_ADMIN') {
          callToast(`You don't have permission to login!`)
        }
        return requestDisconnectDApp()
      }

      setAccessToken(rest.data.access_token)
      setUser(rest.data.user)
      dispatch(setDataUser(rest.data.user))

      await loadWallet(dispatch)
      loadEventWallet(dispatch)

      dispatch(setModalWallet(false))
      navigate('/whitelist')
    } catch (error) {
      setWalletType(undefined)
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  function callToast(message?: string, duration = 5000) {
    setToast(message || '')

    setTimeout(() => {
      setToast('')
    }, duration)
  }

  useEffect(() => {
    if (!!getUser() || !!address) navigate('/whitelist')
  }, [])

  return (
    <>
      <div className='connect-wallet'>
        <div
          onClick={() => collectWallet(SupportedWallets.ethereum)}
          className='connect-wallet__block-connect'
        >
          <div>
            <Metamask />
          </div>
          <div className='connect-wallet__name-wallet'>MetaMask</div>
          <div className='connect-wallet__text-content'>
            {t('ONE_OF_THE_MOST_SECURE_WALLETS')}
          </div>
        </div>

        <div className='connect-wallet__note-info'>
          {t('CLICK_THE_WALLET_ICON_TO_SIGN_IN')}
        </div>
      </div>

      <ToastContainer position='bottom-end'>
        <Toast show={toast?.length > 0} onClose={() => setToast('')}>
          <Toast.Header>
            <strong className='me-auto connect-wallet__red'>Error</strong>
            <small></small>
          </Toast.Header>
          <Toast.Body>{toast}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  )
}

export default ConnectWalletPage
